<h1 mat-dialog-title>Transfer Form</h1>
<mat-dialog-content>
    <app-transfer-form [initialOrders]="orders"></app-transfer-form>
    <div *ngIf="isLoading" class="loading-container">
        <mat-spinner></mat-spinner>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>